import { IconConfig } from "../types";
import { furnished } from "./Furnished";
import { houseBlue } from "./HouseBlue";
import { houseContract } from "./HouseContract";
import { investment } from "./Investment";
import { magnifyingGlass } from "./MagnifiyingGlass";
import { nursingHome } from "./NursingHome";
import { student } from "./Student";
import { suitcase } from "./Suitcase";
import { summerCalendar } from "./SummerCalendar";

export const IconUpiPath: Record<string, IconConfig> = {
  houseBlue: houseBlue,
  suitcase: suitcase,
  investment: investment,
  houseContract: houseContract,
  furnished: furnished,
  summerCalendar: summerCalendar,
  student: student,
  magnifyingGlass: magnifyingGlass,
  nursingHome: nursingHome,
} as const satisfies Record<string, IconConfig>;
